import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

import { NewsStream } from '@ifeng-fe/news-stream';

import '@ifeng-fe/news-stream/lib/NewsStream/style/news-stream-global.css';

/**
 * 定义 ContentLeft 组件
 */
class ContentLeft extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { newsstream, columnId, isEnd } = content;
        const urlId = 'dynamicFragment';
        // console.log('left content-----', content);

        return (
            <div className={styles.yib_left}>
                <div className={`${styles.title_04} clearfix`}>
                    <p>赛事战报</p>
                </div>
                <div className={styles.box_list}>
                    <NewsStream content={newsstream} columnId={columnId} isEnd={isEnd} urlId={urlId} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(ContentLeft);
